import React from 'react';

import {CreateReportPrompt} from './../CreateReportPrompt/CreateReportPrompt';
import {
  EmptyButton,
  EmptyContainer,
  EmptyHeader,
  EmptyHeaderText,
} from './CreateReportPromptHeader.styles';

type CreateReportPromptHeaderProps = {
  entityName: string;
  projectName: string;
  onCreateReportPrompt: () => void;
  createReport: (msg: string) => void;
};

export const CreateReportPromptHeader = ({
  createReport,
  entityName,
  onCreateReportPrompt,
  projectName,
}: CreateReportPromptHeaderProps) => (
  <EmptyContainer>
    <EmptyHeader>
      <EmptyHeaderText>Reports</EmptyHeaderText>
      <EmptyButton
        data-test={`create-report-button`}
        primary
        onClick={() => {
          createReport('empty reports tab');
        }}
        content="Create report"
      />
    </EmptyHeader>
    <CreateReportPrompt
      location={`reports tab`}
      entityName={entityName}
      projectName={projectName}
      onCreateReport={onCreateReportPrompt}
    />
  </EmptyContainer>
);
